
import { useAuth } from '../components/AuthProvider';
import { useState } from 'react';

interface UseAuthCheckReturn {
  checkAuthAndExecute: (callback: () => void) => void;
  isCheckingAuth: boolean;
  showAuthModal: boolean;
  setShowAuthModal: (show: boolean) => void;
  pendingCallback: (() => void) | null;
}

export const useAuthCheck = (): UseAuthCheckReturn => {
  const { user } = useAuth();
  const [isCheckingAuth, setIsCheckingAuth] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingCallback, setPendingCallback] = useState<(() => void) | null>(null);

  const checkAuthAndExecute = (callback: () => void) => {
    setIsCheckingAuth(true);
    
    if (user) {
      // User is authenticated, execute callback immediately
      callback();
      setIsCheckingAuth(false);
    } else {
      // User not authenticated, store callback and show auth modal
      setPendingCallback(() => callback);
      setShowAuthModal(true);
      setIsCheckingAuth(false);
    }
  };

  return {
    checkAuthAndExecute,
    isCheckingAuth,
    showAuthModal,
    setShowAuthModal,
    pendingCallback
  };
};
